import React, { useMemo, useState } from 'react';
import { api, setSesion, ApiError } from './api';

export default function Login({ onLogin, branding }) {
  const [username,setUsername]=useState('');
  const [password,setPassword]=useState('');
  const [error,setError]=useState('');
  const [cargando,setCargando]=useState(false);
  const [seleccion,setSeleccion]=useState(null);
  const [contexto,setContexto]=useState({empresa_id:'',sucursal_id:'',deposito_id:''});

  const opciones=useMemo(()=>{
    if(!seleccion?.contextos) return [];
    return seleccion.contextos.flatMap(c=>(c.depositos||[]).map(d=>({
      key:`${c.empresa_id}:${c.sucursal_id}:${d.id}`,
      empresa_id:c.empresa_id,sucursal_id:c.sucursal_id,deposito_id:d.id,
      label:`${c.empresa_nombre} · ${c.sucursal_nombre} · ${d.nombre}`,
      predeterminado:Boolean(c.es_predeterminado&&d.es_principal),
    })));
  },[seleccion]);

  const guardarSesion=(data)=>{setSesion(data.token,data.user);onLogin(data.user);};

  const intentarLogin=async(e)=>{
    e.preventDefault();setError('');setCargando(true);
    try{
      const data=await api.post('/api/login',{username,password});
      if(data.requires_context){
        setSeleccion(data);
        const lista=data.contextos.flatMap(c=>(c.depositos||[]).map(d=>({c,d})));
        const primero=lista.find(x=>x.c.es_predeterminado&&x.d.es_principal)||lista[0];
        if(!primero) throw new ApiError('No hay depósitos habilitados para este usuario.',409);
        setContexto({empresa_id:String(primero.c.empresa_id),sucursal_id:String(primero.c.sucursal_id),deposito_id:String(primero.d.id)});
      }else guardarSesion(data);
    }catch(err){setError(err instanceof ApiError?err.mensaje:'Error al conectar con el servidor.');}
    finally{setCargando(false);}
  };

  const ingresarContexto=async(e)=>{
    e.preventDefault();setError('');setCargando(true);
    try{
      const data=await api.post('/api/login/contexto',{
        context_token:seleccion.context_token,
        empresa_id:Number(contexto.empresa_id),sucursal_id:Number(contexto.sucursal_id),deposito_id:Number(contexto.deposito_id),
      });
      guardarSesion(data);
    }catch(err){setError(err instanceof ApiError?err.mensaje:'No se pudo seleccionar la empresa.');}
    finally{setCargando(false);}
  };

  const valor=`${contexto.empresa_id}:${contexto.sucursal_id}:${contexto.deposito_id}`;
  const elegir=(key)=>{const o=opciones.find(x=>x.key===key);if(o)setContexto({empresa_id:String(o.empresa_id),sucursal_id:String(o.sucursal_id),deposito_id:String(o.deposito_id)});};

  return <div style={styles.fondo}><div style={styles.tarjeta}>
    {branding?.personalizado&&branding?.logo_url&&<img src={branding.logo_url} alt={branding.nombre_negocio} style={styles.logo}/>}    
    <h1 style={styles.titulo}>{branding?.nombre_negocio||'Casa Alessio'}</h1>
    {!seleccion ? <>
      <p style={styles.subtitulo}>Ingresá tus credenciales</p>
      <form onSubmit={intentarLogin}>
        <input type="text" placeholder="Usuario" value={username} onChange={e=>setUsername(e.target.value)} style={styles.input} autoFocus required/>
        <input type="password" placeholder="Contraseña" value={password} onChange={e=>setPassword(e.target.value)} style={styles.input} required/>
        {error&&<p style={styles.error}>{error}</p>}
        <button type="submit" disabled={cargando} style={styles.boton}>{cargando?'INGRESANDO...':'INGRESAR'}</button>
      </form>
    </>:<>
      <p style={styles.subtitulo}>Elegí dónde vas a trabajar</p>
      <form onSubmit={ingresarContexto}>
        <label style={styles.label}>Empresa, sucursal y depósito</label>
        <select value={valor} onChange={e=>elegir(e.target.value)} style={styles.input} required>
          {opciones.map(o=><option key={o.key} value={o.key}>{o.label}</option>)}
        </select>
        {error&&<p style={styles.error}>{error}</p>}
        <button type="submit" disabled={cargando} style={styles.boton}>{cargando?'ABRIENDO...':'CONTINUAR'}</button>
        <button type="button" onClick={()=>{setSeleccion(null);setError('');}} style={styles.volver}>Volver</button>
      </form>
    </>}
  </div></div>;
}

const styles={
  fondo:{display:'flex',justifyContent:'center',alignItems:'center',minHeight:'100vh',backgroundColor:'#0f172a',padding:'20px'},
  tarjeta:{backgroundColor:'white',padding:'40px',borderRadius:'12px',width:'min(420px,100%)',textAlign:'center',boxShadow:'0 10px 25px rgba(0,0,0,.5)'},
  logo:{maxWidth:'230px',maxHeight:'95px',objectFit:'contain',marginBottom:'14px'},titulo:{margin:'0 0 10px',color:'#0f172a'},subtitulo:{color:'#64748b',marginBottom:'30px'},
  input:{width:'100%',padding:'14px',marginBottom:'15px',borderRadius:'7px',border:'1px solid #cbd5e1',boxSizing:'border-box',fontSize:'14px'},
  label:{display:'block',textAlign:'left',fontSize:'12px',fontWeight:700,color:'#475569',marginBottom:'7px'},
  error:{color:'#dc2626',backgroundColor:'#fef2f2',padding:'10px',borderRadius:'6px',fontSize:'13px',marginBottom:'15px'},
  boton:{width:'100%',padding:'15px',backgroundColor:'#3b82f6',color:'white',fontWeight:'bold',border:'none',borderRadius:'6px',cursor:'pointer',fontSize:'15px'},
  volver:{marginTop:'12px',background:'none',border:'none',color:'#64748b',cursor:'pointer',textDecoration:'underline'}
};
